module.exports = __webpack_public_path__ + "static/media/pexels-photo-3775561.01cc7027.jpg";